// styles
import classes from "./styles.module.css";

export default function CustomDropDown({ value, list, onSelect }) {
  return (
    <select
      value={value}
      className={classes.root}
      onChange={(e) => onSelect(+e.target.value)}
    >
      <option value="-1" disabled hidden>
        -- Выбрать --
      </option>

      {list.map((item, ind) => (
        <option key={ind} value={ind}>
          {item.title} ({item.count} шт)
        </option>
      ))}
    </select>
  );
}
